// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"532":"pagepilot","792":"hotspot-image"}[chunkId] + "." + {"532":"65664c06","792":"64e4ed63"}[chunkId] + ".js";
};